import { render, staticRenderFns } from "./SearchProductPage.vue?vue&type=template&id=95ad24cc&scoped=true&"
import script from "./SearchProductPage.vue?vue&type=script&lang=js&"
export * from "./SearchProductPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductPage.vue?vue&type=style&index=0&id=95ad24cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad24cc",
  null
  
)

export default component.exports